export enum FinishingOptionId {
    Basic = 'basic',
    Standard = 'standard',
    Premium = 'premium',
    Luxe = 'luxe',
}

export default FinishingOptionId;
